/**
 * IMPORTS
 */

import { remessaDownloadZipRepository } from "@/repositories/remessas/remessa-zip-download";

/**
 * Função que faz o download zip da remessa 🛠️.
 */
const handleGetDownloadZipRemessa = async (
  accessToken: string,
  remessa_id: number,
  numero_remessa: number
) => {
  try {
    const data = await remessaDownloadZipRepository.getDownloadZipRemessa(
      accessToken,
      remessa_id,
      numero_remessa
    );

    return data;
  } catch (error) {
    console.log("ERROR EM FAZER DOWNLOAD REMESSA: ", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export { handleGetDownloadZipRemessa };
